'use strict';
var $ = require('jquery');

$(document).on('jsfAjaxEvent', function (event) {
    if (event.detail.fireType === "always") {
        init();
    }
});

var timer;

function init() {
    var myProfileForm = $("#myProfileForm");
    var myProfileFormButton = $("#myProfileSaveBtn .submitButton");

    if (myProfileForm.length >= 1 && myProfileFormButton.length >= 1) {
        var fieldSets = myProfileForm.find("fieldset[data-autosaveinited!='true']");
	fieldSets.attr("data-autosaveinited", "true");
        fieldSets.on("keyup focusin", function(){
            startTimer();
        });
    }

    function startTimer() {
        clearTimeout(timer);
        timer = setTimeout(run, 10000);
    }

    function run() {
        clearTimeout(timer);
        myProfileFormButton.trigger("click");
    }
}

module.exports = {
    init: init
}
